module.exports = __webpack_public_path__ + "img/10.b613e1d3.png";